module.exports = __webpack_public_path__ + "static/media/icon-delete.5558183e.svg";